import { ButtonProps } from '.';
import { focusRing, focusRingNoGap } from '../../Themes/base/focusRing';
import { borderColor, borderRadius, borderStyle, borderWidth, marginSize } from '../../Utilities/utils/Theming';

const getshapeComplex = (scaleA: string, scaleB: string, scaleC: string, scaleD: string) => {
	return {
		borderBottomLeftRadius: scaleA,
		borderBottomRightRadius: scaleB,
		borderTopRightRadius: scaleC,
		borderTopLeftRadius: scaleD,
	};
};

const onlyIcon = (childrenText: any, initProps: any) => {
	let enhancers = 0;
	initProps.iconBefore && enhancers++;
	initProps.iconAfter && enhancers++;
	initProps.startEnhancer && enhancers++;
	initProps.endEnhancer && enhancers++;

	return (!childrenText || childrenText === '') && enhancers == 1;
};

export const buttonBaseStyle = (_props: any) => {
	return {
		...marginSize('0', '0', '0', '0'),
		fontFamily: 'var(--epods--font-base-semibold)', // todo check if needed
		width: 'auto',
		verticalAlign: 'middle',
		...borderWidth('0'),
		position: 'relative',
		transitionDuration: '0 !important', //TODO: check to remove !important,
		textDecoration: 'none',
		boxShadow: 'none',
		':hover': {
			cursor: 'pointer',
		},
	};
};

export const buttonSizes = (props: ButtonProps, initProps: any, childrenText: any) => {
	return props.size === 'compact'
		? {
			fontFamily: 'var(--epods--font-secondary-semibold)',
			fontSize: 'var(--epods--button-compact-font-size)',
			lineHeight: 'var(--epods--button-compact-line-height)',
			fontWeight: 100,
			paddingTop: 'var(--epods--button-compact-vertical-padding)', //'var(--epods--topBottom-space-button)',
			paddingBottom: 'var(--epods--button-compact-vertical-padding)',
			paddingLeft: 'var(--epods--button-compact-horizontal-padding)', //'var(--epods--side-space-button)',
			paddingRight: 'var(--epods--button-compact-horizontal-padding)', //'var(--epods--side-space-button)',
			height: 'var(--epods--button-compact-height)', //'var(--epods--height-button-compact)', // button height
			maxWidth: onlyIcon(childrenText, initProps) ? 'var(--epods--button-onlyicon-compact-width)' : 'unset',
			minWidth: onlyIcon(childrenText, initProps) ? 'var(--epods--button-onlyicon-compact-width)' : 'unset',
		}
		: props.size === 'mini'
			? {
				fontFamily: 'var(--epods--font-secondary-semibold)',
				fontSize: 'var(--epods--button-mini-font-size)',
				lineHeight: 'var(--epods--button-mini-line-height)',
				fontWeight: 100,
				paddingTop: 'var(--epods--button-mini-vertical-padding)', //'var(--epods--topBottom-space-button)',
				paddingBottom: 'var(--epods--button-mini-vertical-padding)',
				paddingLeft: 'var(--epods--button-mini-horizontal-padding)', //'var(--epods--side-space-button)',
				paddingRight: 'var(--epods--button-mini-horizontal-padding)', //'var(--epods--side-space-button)',
				height: 'var(--epods--button-mini-height)', //'var(--epods--height-button)',
				maxWidth: onlyIcon(childrenText, initProps) ? 'var(--epods--button-onlyicon-mini-width)' : 'unset',
				minWidth: onlyIcon(childrenText, initProps) ? 'var(--epods--button-onlyicon-mini-width)' : 'unset',
			}
			: props.size === 'large'
				? {
					fontFamily: 'var(--epods--font-secondary-semibold)',
					fontSize: 'var(--epods--button-large-font-size)',
					lineHeight: 'var(--epods--button-large-line-height)',
					fontWeight: 100,
					paddingTop: 'var(--epods--button-large-vertical-padding)', //'var(--epods--topBottom-space-button)',
					paddingBottom: 'var(--epods--button-large-vertical-padding)',
					paddingLeft: 'var(--epods--button-large-horizontal-padding)', //'var(--epods--side-space-button)',
					paddingRight: 'var(--epods--button-large-horizontal-padding)', //'var(--epods--side-space-button)',
					height: 'var(--epods--button-large-height)', //'var(--epods--height-button-large)',
					maxWidth: onlyIcon(childrenText, initProps) ? 'var(--epods--button-onlyicon-large-width)' : 'unset',
					minWidth: onlyIcon(childrenText, initProps) ? 'var(--epods--button-onlyicon-large-width)' : 'unset',
				}
				: {
					fontFamily: 'var(--epods--font-secondary-semibold)',
					fontSize: 'var(--epods--button-default-font-size)',
					lineHeight: 'var(--epods--button-default-line-height)',
					fontWeight: 100,
					paddingTop: 'var(--epods--button-default-vertical-padding)', //'var(--epods--topBottom-space-button)',
					paddingBottom: 'var(--epods--button-default-vertical-padding)',
					paddingLeft: 'var(--epods--space-inset-xs2)', //'var(--epods--side-space-button)',
					paddingRight: 'var(--epods--space-inset-xs2);', //'var(--epods--side-space-button)',
					height: 'var(--epods--button-default-height)', //'var(--epods--height-button)',

					maxWidth: onlyIcon(childrenText, initProps) ? 'var(--epods--button-onlyicon-default-width)' : 'unset',
					minWidth: onlyIcon(childrenText, initProps) ? 'var(--epods--button-onlyicon-default-width)' : 'unset',
				};
};

export const shapes = (props: any) => {
	const _shape = props.buttongroupShape || props.shape;
	return _shape === 'default'
		? { ...borderRadius('0') } // TODO: review 3.0
		: _shape === 'pill'
			? { ...borderRadius('18px') }
			: _shape === 'round'
				? { ...borderRadius('var(--epods--border-radius)') }
				: _shape === 'square'
					? { ...borderRadius('0px') }
					: _shape === 'last'
						? { ...getshapeComplex('0px', 'var(--epods--border-radius)', 'var(--epods--border-radius)', '0px') }
						: _shape === 'first'
							? { ...getshapeComplex('var(--epods--border-radius)', '0px', '0px', 'var(--epods--border-radius)') }
							: _shape === 'last-vertical'
								? { ...getshapeComplex('var(--epods--border-radius)', 'var(--epods--border-radius)', '0px', '0px') }
								: _shape === 'first-vertical'
									? { ...getshapeComplex('0px', '0px', 'var(--epods--border-radius)', 'var(--epods--border-radius)') }
									: { ...borderRadius('var(--epods--border-radius)') };
};

export const buttonKinds = (
	props: any,
	isSelected: boolean,
	navigationStyle: boolean | undefined,
	parentTheme?: string,
) => {
	const _theme = parentTheme || props.theme;

	return navigationStyle
		? buttonThemeNavigation(props, isSelected)
		: _theme === 'primary'
			? buttonThemePrimary(props, isSelected)
			: _theme === 'secondary'
				? buttonThemeSecondary(props, isSelected)
				: _theme === 'tertiary'
					? buttonThemeTertiary(props, isSelected)
					: _theme === 'tertiary-phantom'
						? buttonThemePhantomTertiary(props, isSelected)
						: _theme === 'toggle'
							? buttonThemeToggle(props, isSelected)
							: _theme === 'toggle-phantom'
								? buttonThemePhantomToggle(props, isSelected)
								: _theme === 'minimal'
									? buttonThemeMinimal(props, isSelected)
									: _theme === 'outline'
										? buttonThemeOutline(props, isSelected)
										: _theme === 'tab'
											? buttonThemeTab(props, isSelected)
											: buttonThemePrimary(props, isSelected);
};

const buttonThemePrimary = (props: any, isSelected: boolean) => {
	return {
		backgroundColor:
			props.isSelected || isSelected ? 'var(--epods--color-bg-primary-active)' : 'var(--epods--color-bg-primary)',
		color: 'var(--epods--color-text-button)',
		fill: 'var(--epods--color-text-button)',
		':hover': {
			color: 'var(--epods--color-text-button)',
			fill: 'var(--epods--color-text-button)',
			backgroundColor: props.disabled
				? 'var(--epods--color-bg-primary-disabled)'
				: props.isSelected || isSelected
					? 'var(--epods--color-bg-primary-active)'
					: 'var(--epods--color-bg-primary-hover)',
			// Note: we need to override the styles on the css framework
			textDecoration: 'none !important',
		},
		':active': {
			backgroundColor: 'var(--epods--color-bg-primary-active)',
			color: 'var(--epods--color-text-button)',
			fill: 'var(--epods--color-text-button)',
		},
		':disabled, [aria-disabled="true"]': {
			// Note: we need to use !important here, otherwise when the button
			// has aria-disabled, it will be overriden by button:hover styles
			// as it has more specificity
			// :hover:not([aria-disabled="true"]) doesn't seem to work either
			backgroundColor: 'var(--epods--color-bg-primary-disabled)',
			color: 'var(--epods--color-text-button)',
			fill: 'var(--epods--color-text-button)',
			cursor: 'default',
		},
		':focus': focusRing,
		':visited': {
			color: 'var(--epods--color-text-button)',
		},
	};
};

const buttonThemeSecondary = (props: any, isSelected: boolean) => {
	return {
		backgroundColor:
			props.isSelected || isSelected
				? 'var(--epods--color-bg-secondary-active)'
				: 'var(--epods--color-bg-secondary)',
		color:
			props.isSelected || isSelected
				? 'var(--epods--color-text-button-secondary-active)'
				: 'var(--epods--color-text-button-secondary)',
		fill:
			props.isSelected || isSelected
				? 'var(--epods--color-text-button-secondary-active)'
				: 'var(--epods--color-text-button-secondary)',

		...borderColor('var(--epods--color-border)'),
		...borderWidth('1px'),
		...borderStyle('solid'),

		':hover': {
			backgroundColor: props.disabled
				? 'var(--epods--color-bg-secondary-disabled)'
				: 'var(--epods--color-bg-secondary-hover)',
			// Note: we need to override the styles on the css framework
			textDecoration: 'none !important',
		},
		':active': {
			backgroundColor: 'var(--epods--color-bg-secondary-active)',
			color: props.disabled
				? 'var(--epods--color-text-button-secondary-active)'
				: 'var(--epods--color-text-button-secondary-active)',
			fill: props.disabled
				? 'var(--epods--color-text-button-secondary-active)'
				: 'var(--epods--color-text-button-secondary-active)',
		},
		':disabled': {
			...borderColor('var(--epods--color-border-light)'),
			backgroundColor: 'var(--epods--color-bg-secondary-disabled)',
			color: 'var(--epods--color-text-button-secondary-disabled)',
			fill: 'var(--epods--color-text-button-secondary-disabled)',
			cursor: 'default',
		},
		':focus': focusRing,
		':visited': {
			color:
				props.isSelected || isSelected
					? 'var(--epods--color-text-button-secondary-active)'
					: 'var(--epods--color-text-button-secondary)',
		},
	};
};

const buttonThemeTertiary = (props: any, isSelected: boolean) => {
	return {
		...borderColor('var(--epods--color-border)'),
		...borderWidth('1px'),
		...borderStyle('solid'),
		backgroundColor:
			props.isSelected || isSelected
				? 'var(--epods--color-bg-tertiary-active)'
				: 'var(--epods--color-bg-tertiary)',
		color:
			props.isSelected || isSelected
				? 'var(--epods--color-text-button-tertiary-active)'
				: 'var(--epods--color-text-button-tertiary)',
		fill:
			props.isSelected || isSelected
				? 'var(--epods--color-text-button-tertiary-active)'
				: 'var(--epods--color-text-button-tertiary)',

		'button:first-child': {
			borderLeft: '1px',
		},
		':hover': {
			color: props.disabled
				? 'var(--epods--color-text-button-tertiary-disabled)'
				: 'var(--epods--color-text-button-tertiary-hover)',
			fill: props.disabled
				? 'var(--epods--color-text-button-tertiary-disabled)'
				: 'var(--epods--color-text-button-tertiary-hover)',
			backgroundColor: props.disabled
				? 'var(--epods--color-bg-tertiary-disabled)'
				: props.isSelected
					? 'var(--epods--color-bg-tertiary-active)'
					: 'var(--epods--color-bg-tertiary-hover)',
			// Note: we need to override the styles on the css framework
			textDecoration: 'none !important',
		},
		':active': {
			color: 'var(--epods--color-text-button-tertiary-active)',
			fill: 'var(--epods--color-text-button-tertiary-active)',
			backgroundColor: 'var(--epods--color-bg-tertiary-active)',
		},
		':disabled': {
			...borderColor('var(--epods--color-border-light)'),
			backgroundColor: 'var(--epods--color-bg-tertiary-disabled)',
			color: 'var(--epods--color-text-button-tertiary-disabled)',
			fill: 'var(--epods--color-text-button-tertiary-disabled)',
			cursor: 'default',
		},
		':focus': {
			...focusRingNoGap,
			...borderColor('transparent !important'),
		},
		':visited': {
			color:
				props.isSelected || isSelected
					? 'var(--epods--color-text-button-tertiary-active)'
					: 'var(--epods--color-text-button-tertiary)',
		},
	};
};

const buttonThemePhantomTertiary = (props: any, isSelected: boolean) => {
	return {
		...borderColor('transparent'),
		...borderWidth('1px'),
		...borderStyle('solid'),
		backgroundColor: props.isSelected || isSelected ? 'var(--epods--color-bg-tertiary-active)' : 'transparent',
		color:
			props.isSelected || isSelected
				? 'var(--epods--color-text-button-tertiary-active)'
				: 'var(--epods--color-text-button-tertiary)',
		fill:
			props.isSelected || isSelected
				? 'var(--epods--color-text-button-tertiary-active)'
				: 'var(--epods--color-text-button-tertiary)',

		'button:first-child': {
			borderLeft: '1px',
		},
		':hover': {
			color: props.disabled
				? 'var(--epods--color-text-button-tertiary-disabled)'
				: 'var(--epods--color-text-button-tertiary-hover)',
			fill: props.disabled
				? 'var(--epods--color-text-button-tertiary-disabled)'
				: 'var(--epods--color-text-button-tertiary-hover)',
			backgroundColor: props.disabled
				? 'var(--epods--color-bg-tertiary-disabled)'
				: props.isSelected
					? 'var(--epods--color-bg-tertiary-active)'
					: 'var(--epods--color-bg-tertiary-hover)',
			// Note: we need to override the styles on the css framework
			textDecoration: 'none !important',
		},
		':active': {
			color: 'var(--epods--color-text-button-tertiary-active)',
			fill: 'var(--epods--color-text-button-tertiary-active)',
			backgroundColor: 'var(--epods--color-bg-tertiary-active)',
		},
		':disabled': {
			backgroundColor: 'var(--epods--color-bg-tertiary-disabled)',
			color: 'var(--epods--color-text-button-tertiary-disabled)',
			fill: 'var(--epods--color-text-button-tertiary-disabled)',
			cursor: 'default',
		},
		':focus': focusRing,
		':visited': {
			color:
				props.isSelected || isSelected
					? 'var(--epods--color-text-button-tertiary-active)'
					: 'var(--epods--color-text-button-tertiary)',
		},
	};
};

const buttonThemeToggle = (props: any, isSelected: boolean) => {
	return {
		backgroundColor:
			props.isSelected || isSelected ? 'var(--epods--color-bg-toggle-active)' : 'var(--epods--color-bg-tertiary)',
		color:
			props.isSelected || isSelected
				? 'var(--epods--color-text-button-toggle-active)'
				: 'var(--epods--color-text-button-tertiary)',
		fill:
			props.isSelected || isSelected
				? 'var(--epods--color-text-button-toggle-active)'
				: 'var(--epods--color-text-button-tertiary)',
		...borderColor('var(--epods--color-border)'),
		...borderWidth('1px'),
		...borderStyle('solid'),
		':hover': {
			color: props.disabled
				? 'var(--epods--color-text-button-tertiary-disabled)'
				: props.isSelected
					? 'var(--epods--color-text-button-toggle-active)'
					: 'var(--epods--color-text-button-toggle-hover)',
			fill: props.disabled
				? 'var(--epods--color-text-button-tertiary-disabled)'
				: props.isSelected
					? 'var(--epods--color-text-button-toggle-active)'
					: 'var(--epods--color-text-button-toggle-hover)',
			backgroundColor: props.disabled
				? 'var(--epods--color-bg-toggle-disabled)'
				: props.isSelected
					? 'var(--epods--color-bg-toggle-active)'
					: 'var(--epods--color-bg-toggle-hover)',
		},
		':active': {
			color: 'var(--epods--color-text-button-toggle-active)',
			fill: 'var(--epods--color-text-button-toggle-active)',
			backgroundColor: 'var(--epods--color-bg-toggle-active)',
		},
		':disabled': {
			...borderColor('var(--epods--color-border-light)'),
			cursor: 'default',
			color: 'var(--epods--color-text-button-tertiary-disabled)',
			fill: 'var(--epods--color-text-button-tertiary-disabled)',
			backgroundColor: 'var(--epods--color-bg-toggle-disabled)',
		},
		':focus': focusRing,
	};
};

const buttonThemePhantomToggle = (props: any, isSelected: boolean) => {
	return {
		backgroundColor: props.isSelected || isSelected ? 'var(--epods--color-bg-toggle-active)' : 'transparent',
		color:
			props.isSelected || isSelected
				? 'var(--epods--color-text-button-toggle-active)'
				: 'var(--epods--color-text-button-tertiary)',
		fill:
			props.isSelected || isSelected
				? 'var(--epods--color-text-button-toggle-active)'
				: 'var(--epods--color-text-button-tertiary)',

		...borderColor('transparent'),
		...borderWidth('1px'),
		...borderStyle('solid'),
		':hover': {
			color: props.disabled
				? 'var(--epods--color-text-button-tertiary-disabled)'
				: props.isSelected
					? 'var(--epods--color-text-button-toggle-active)'
					: 'var(--epods--color-text-button-toggle-hover)',
			fill: props.disabled
				? 'var(--epods--color-text-button-tertiary-disabled)'
				: props.isSelected
					? 'var(--epods--color-text-button-toggle-active)'
					: 'var(--epods--color-text-button-toggle-hover)',
			backgroundColor: props.disabled
				? 'var(--epods--color-bg-toggle-disabled)'
				: props.isSelected
					? 'var(--epods--color-bg-toggle-active)'
					: 'var(--epods--color-bg-toggle-hover)',
		},
		':active': {
			color: 'var(--epods--color-text-button-toggle-active)',
			fill: 'var(--epods--color-text-button-toggle-active)',
			backgroundColor: 'var(--epods--color-bg-toggle-active)',
		},
		':disabled': {
			cursor: 'default',
			color: 'var(--epods--color-text-button-tertiary-disabled)',
			fill: 'var(--epods--color-text-button-tertiary-disabled)',
			backgroundColor: 'var(--epods--color-bg-toggle-disabled)',
		},
		':focus': focusRing,
	};
};

const buttonThemeMinimal = (props: any, isSelected: boolean) => {
	return {
		backgroundColor:
			props.isSelected || isSelected ? 'var(--epods--color-bg-visited)' : 'transparent',
		color: 'inherit',
		/* props.isSelected || isSelected
			? 'var(--epods--color-text-button-tertiary-active)'
			: 'var(--epods--color-text-button-tertiary)', */
		fill: 'inherit',
		/* props.isSelected || isSelected
			? 'var(--epods--color-text-button-tertiary-active)'
			: 'var(--epods--color-text-button-tertiary)', */

		':hover': {
			color: props.disabled
				? 'var(--epods--color-text-disabled)'
				: 'var(--epods--color-text-ds-dark)',
			fill: props.disabled
				? 'var(--epods--color-text-disabled)'
				: 'var(--epods--color-text-ds-dark)',
			backgroundColor: props.disabled
				? 'transparent'
				: props.isSelected
					? 'var(--epods--color-bg-visited)'
					: 'transparent',
			textDecoration: 'none !important',
			// color: 'var(--epods--color-progress-steps)',
			// fill: 'var(--epods--color-progress-steps)',
			// backgroundColor: 'var(--epods--color-bg-secondary-hover)',
		},
		':active': {
			color: 'inherit',
			fill: 'inherit',
			backgroundColor: 'var(--epods--color-bg-visited)',
		},
		':disabled': {
			cursor: 'default',
			color: 'var(--epods--color-text-disabled)',
			fill: 'var(--epods--color-text-disabled)',
			backgroundColor: 'transparent',
		},
		':focus': focusRing,
	};
};

const buttonThemeOutline = (props: any, isSelected: boolean) => {
	return {
		...borderWidth('1px'),
		...borderStyle('solid'),
		...borderColor('var(--epods--color-border)'),
		...borderRadius('0'),
		marginRight: '0px',
		backgroundColor: props.isSelected || isSelected ? 'var(--epods--color-border-active)' : 'white',
		zIndex: props.isSelected || isSelected ? 1 : 0,
		':hover': {
			backgroundColor: 'var(--epods--color-border)',
		},
		':active': {
			backgroundColor: 'var(--epods--color-border-active)',
		},
		':disabled': {
			cursor: 'default',
			backgroundColor: 'white',
			':hover': {
				backgroundColor: 'white',
			},
		},
		':focus': focusRing,
	};
};

const buttonThemeTab = (props: any, isSelected: boolean) => {
	return {
		backgroundColor: 'transparent',
		color: props.isSelected || isSelected ? 'var(--epods--tab-color-active)' : 'var(--epods--color-text-tab)',
		fill: props.isSelected || isSelected ? 'var(--epods--tab-color-active)' : 'var(--epods--color-text-tab)',
		':hover': {
			color: 'var(--epods--color-text-tab-hover)',
			fill: 'var(--epods--color-text-tab-hover)',
			backgroundColor: 'transparent',
		},
		':active': {
			color: 'var(--epods--color-text-primary-action)',
			fill: 'var(--epods--color-text-primary-action)',
			backgroundColor: 'transparent',
		},
		':disabled': {
			cursor: 'default',
			color: 'var(--epods--color-text-tab-disabled)',
			fill: 'var(--epods--color-text-tab-disabled)',
			backgroundColor: 'transparent',
		},
		':focus': focusRing,
	};
};

const buttonThemeNavigation = (props: any, isSelected: boolean) => {
	return {
		backgroundColor: props.isSelected || isSelected ? 'var(--epods--color-header-navigation-focus)' : 'transparent',
		color:
			props.isSelected || isSelected ? 'var(--epods--color-text-primary-action)' : 'var(--epods--color-outline)',
		fill:
			props.isSelected || isSelected ? 'var(--epods--color-text-primary-action)' : 'var(--epods--color-outline)',
		flexGrow: '0',
		flexShrink: '0',
		flexBasis: 'var(--epods-button-theme-navigation-width)',
		width: 'var(--epods-button-theme-navigation-width)',
		height: 'var(--epods-button-theme-navigation-height)',
		':hover': {
			backgroundColor: 'var(--epods--color-header-navigation-focus)',
		},
		':active': {
			backgroundColor: 'var(--epods--color-header-navigation-focus)',
			color: 'var(--epods--tab-color-active)',
			fill: 'var(--epods--tab-color-active)',
		},
		':disabled': {
			backgroundColor: 'transparent',
			cursor: 'default',
			color: 'var(--epods--tab-color-disabled)',
			fill: 'var(--epods--tab-color-disabled)',
		},
		':focus': {
			outlineColor: 'var(--epods--color-header-navigation-focus)',
			outlineStyle: 'solid',
			outlineWidth: '2px',
		},
	};
};
